/**
 * Determine if current hostname is the admin portal or a tenant portal.
 * Admin portal is the base domain (e.g., sa1-dal.watchcenter365.com).
 * Tenant portals are subdomains (e.g., demo.sa1-dal.watchcenter365.com).
 */

const ADMIN_HOSTNAMES = [
  'sa1-dal.watchcenter365.com',
  'localhost',
  '127.0.0.1',
];

export function isAdminPortal(): boolean {
  const hostname = window.location.hostname;
  return ADMIN_HOSTNAMES.includes(hostname);
}

export function isTenantPortal(): boolean {
  return !isAdminPortal();
}

export function getTenantSlugFromHostname(): string | null {
  const hostname = window.location.hostname;
  // Pattern: {slug}.sa1-dal.watchcenter365.com
  const match = hostname.match(/^([^.]+)\.sa1-dal\.watchcenter365\.com$/);
  return match ? match[1] : null;
}
